<template>
  <div class="single-bundle-list">
    <p class="mb-2 text-center text-size-small text-primary font-weight-bold">Other Buying Options</p>
    <ul class="list-unstyled mx-3 mb-0">
      <li v-for="(product, index) in $page.props.product.bundles" :key="product.id" :class="{'border-top mt-2 pt-2':index !== 0}" class="mb-2 pb-0 row d-flex align-items-center justify-content-between">
        <div class="mr-4 price-container">
          <p v-if="product.included_description" class="font-weight-bold m-0 text-secondary text-nowrap">{{product.included_description}}</p>
          <p v-else class="m-0 text-secondary font-weight-bold">{{product.included_qty}} x {{original_product.sku}}</p>
          <p v-if="savedAmount(product) > 0" class="text-success text-size-small mb-0 text-nowrap"><i class="fas fa-tag mr-1 fa-sm" />You save <strong>${{formatCurrency(savedAmount(product))}}</strong></p>
          <p class="m-0 font-weight-bold text-dark"><span class="text-success">${{formatCurrency(product.included_bundle_total)}}</span></p>
        </div>

        <div class="d-flex flex-column">
          <p class="text-secondary mb-0 font-italic text-size-small">${{formatCurrency(product.included_bundle_total/product.included_qty)}} each</p>
          <ProductQty
            :product="product"
            :variation_product="original_product"
            :cart_items="cart_items"
            :routes="routes"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import ProductQty from '@/Components/Shop/ProductQty'

  export default {
    components: {
      ProductQty
    },
    props: {
      routes: Object,
      original_product: Object,
      cart_items: Array,
      isWholesale: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      savedAmount(product) {
        const totalPrice = this.isWholesale ? product.wholesale_price : product.retail_price
        return (product.included_bundle_total - totalPrice)
      },
    },
  }
</script>

<style>
  .single-bundle-list .shop-quantity input {
    max-height: 30px;
  }

  .single-bundle-list .price-container {
    width: 115px;
  }
</style>
